
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { Modal,notification } from 'ant-design-vue'
import {  h } from 'vue';

export default defineComponent({
  setup () {
    const store = useStore()
    const actualData = ref<Array<any>>([])
    const from = ref()
    const to = ref()
    const router = useRouter()
    const current_page = ref(1)

    const fields = ref([
      {
        title: 'Module',
        dataIndex: 'module_name',
      },
      {
        title: 'User',
        dataIndex: 'user_full_name',
      },
      {
        title: 'Action',
        dataIndex: 'action',
      },
      {
        title: 'Account Type',
        dataIndex: 'account_type',
      },
      {
        title: 'Date',
        dataIndex: 'date',
      },
      {
        title: 'Payload',
        slots: {customRender: 'audit_logs_payload'},
        width: '40%'
      },
    ])

    const index = (payload = {page: 1}) => {
      // if (!from.value || !to.value) {
      //   return
      // }
      payload.page = current_page.value;
      const new_payload = {
        page: payload.page ?? 1,
        from: '',
        to: '',
      };
      if(from.value || to.value) {
        new_payload.from = from.value.format('YYYY-MM-DD')
        new_payload.to = to.value.format('YYYY-MM-DD')
      }
      

      store.dispatch('AuditLog/index',new_payload).then((res) => {
        // actualData.value = Array.isArray(res.data.data)
        //     ? res.data.data
        //     : Object.keys(res.data.data).map(key => res.data.data[key])

            if(current_page.value > res.data.last_page) {
              current_page.value = res.data.last_page
              index()
            }
      })
    }

    // const index = () => {
    // //   if (!checkSidebar('Audit Logs')) {
    //     router.push('/dashboard')
    // //   }
    // }

    const filterRecord = (payload: any) => {
      current_page.value = payload.page;
      index(payload)
    }

    onMounted(() => {
      store.dispatch('AuditLog/index').then((res) => {
        actualData.value = Array.isArray(res.data.data)
            ? res.data.data
            : Object.keys(res.data.data).map(key => res.data.data[key])
      })
    })

    const items = computed(() => store.getters['AuditLog/items'])
    const loading = computed(() => store.getters['AuditLog/status'])

    const api = axios.create({
      baseURL: process.env.VUE_APP_REPORT_URL, // Replace with your API base URL
      headers: {
        'Content-Type': 'application/json', // You can add any default headers here
          Authorization: `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_TOKEN')}`, // Example of setting an authorization token from localStorage
      },
    });

    const headers = {
      headers: {
        'Authorization': `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_TOKEN')}`
      }
    }
    const handleSubmit =  () => {
      const xhr = new XMLHttpRequest();
      
      let download_url =  process.env.VUE_APP_REPORT_URL + 'audit_log_report';
          
      xhr.open('GET', download_url, true);
      xhr.onload = () => {
        if (xhr.status === 200) {
          // Successful response
          const blob = xhr.response;
          const fileName = 'Audit_Logs.xlsx';

          // Create a link element to trigger the download
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = fileName;
          a.style.display = 'none';

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          // Handle errors
          console.error('API Error:', xhr.statusText);
        }
      };
      xhr.setRequestHeader("Authorization", `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_TOKEN')}`);
      xhr.responseType = 'blob';
      xhr.send();
    }

    return {
      fields,
      items,
      filterRecord,
      loading,
      actualData,
      from,
      to,
      api,
      headers,
      handleSubmit,
      index
    }
  }
})
